module.exports = __webpack_public_path__ + "static/media/medium_platform.e14051d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/sprites/gameSpacePort/medium_platform.png
// module id = 2481
// module chunks = 0